exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".error-block {\n  margin: 0 auto;\n  text-align: center;\n  padding-top: 24px; }\n\n.error-code {\n  font-size: 60px;\n  font-weight: 200;\n  line-height: 1em;\n  opacity: .5;\n  margin-top: 0; }\n\n.error-text {\n  letter-spacing: normal;\n  line-height: 24px;\n  margin-top: 24px;\n  margin-bottom: 0;\n  font-weight: 400;\n  font-size: 14px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/common/not-found/not-found.scss
// module id = imZL
// module chunks = 0